class AE2Configurator {

    cd = 0;
    s = 0;
    sp = 0;
    w = 0;
    h = 0;
    q = 1;
    o = 0;
    d = 0;
    wt = 1;
    bat = 0;
    url_cart = '';

    constructor()
    {
        this.container = $('#ae2-configurator #configurator-container');
        this.loading_screen = $('#ae2-loading-screen');

        if( !this.container.length ||
            ae2_url === undefined || 
            ae2_token === undefined ){ return }

        this.url = ae2_url;
        this.token = ae2_token;
        this.load();
    }

    load()
    {
        let formData = new FormData();
        formData.append('action', 'load');
        formData.append('token', this.token);
        formData.append('params[cd]', this.cd);
        formData.append('params[s]', this.s);
        formData.append('params[sp]', this.sp);
        formData.append('params[o]', this.o);
        formData.append('params[w]', this.w);
        formData.append('params[h]', this.h);
        formData.append('params[q]', this.q);
        formData.append('params[d]', this.d);
        formData.append('params[wt]', this.wt);
        formData.append('params[bat]', this.bat);

        this.loading();

        $.ajax({
            type: 'POST',
            dataType: 'JSON',
            url: this.url,
            contentType: false,
            processData: false,
            data: formData,
            context : this,
            'success' : function(response){
                if(response.success && response.content)
                {
                    console.log(response);

                    this.loadContent(response.content);

                    if(response.message != ''){

                        //this.dropMessage(response.message, false);
                    }

                    this.cd = response.cd;
                    this.s = response.s;
                    this.sp = response.sp;
                    this.o = response.o;
                    this.w = response.w;
                    this.h = response.h;
                    this.q = response.q;

                }else{
                    //this.dropMessage(response.message);
                }
                this.loading(false);
            },
            'error' : function(){
                this.dropMessage("Erreur technique, veuillez recharger la page. Si le problème persiste, merci de contacter l'administrateur du site.");
                this.loading(false);
            }
        });   
    }

    loadEvents()
    {
        const input_actions = document.querySelectorAll('#ae2-configurator .action');

        if(input_actions){

            input_actions.forEach( function(input_action){

                input_action.addEventListener('click', function(e){

                    let action = $(e.currentTarget).data('action');
                    let params = $(e.currentTarget).data('params');
                    if(params === undefined){
                        params = {};
                    }else{
                        params = conf.parseParams(params);
                    }
                    console.log(action);
                    console.log(params);
                    if(action){
                        conf.handleAction(action, params);
                    }
                });
            });
        }

        const wt_input = document.querySelector('#with-tax');

        if(wt_input){

            wt_input.addEventListener('click', function(e){

                let action = 'select';
                let params = {};
                params.type = 'wt';
                params.v = (e.currentTarget.checked ? 1 : 0);
                conf.handleAction(action, params);
            });
        }

        const bat_input = document.querySelector('#bat');

        if(bat_input){

            bat_input.addEventListener('click', function(e){

                let action = 'select';
                let params = {};
                params.type = 'bat';
                params.v = (e.currentTarget.checked ? 1 : 0);
                conf.handleAction(action, params);
            });
        }

        const opt_input = document.querySelector('#finition-option');

        if(opt_input){

            opt_input.addEventListener('change', function(e){
                
                let action = 'select';
                let params = {};
                params.type = 'opt';
                params.v = parseInt(e.currentTarget.value);
                conf.handleAction(action, params);
            });
        }

        const width_input = document.querySelector('#dim-width');

        if(width_input){

            width_input.addEventListener('focusout', function(e){
                
                let width = parseInt(e.currentTarget.value);

                if(width != conf.w){

                    if(width <= 0){ width = 1; }

                    let action = 'select';
                    let params = {};
                    params.type = 'width';
                    params.v = width;
                    conf.handleAction(action, params);
                }
            });
        }

        const height_input = document.querySelector('#dim-height');

        if(height_input){

            height_input.addEventListener('focusout', function(e){
                
                let height = parseInt(e.currentTarget.value);

                if(height != conf.h){

                    if(height <= 0){ height = 1; }

                    let action = 'select';
                    let params = {};
                    params.type = 'height';
                    params.v = height;
                    conf.handleAction(action, params);
                }
            });
        }

        const qty_input = document.querySelector('#sticker-quantity');

        if(qty_input){

            qty_input.addEventListener('focusout', function(e){
                
                let qty = parseInt(e.currentTarget.value);

                if(qty != conf.q){

                    if(qty <= 0){ qty = 1; }

                    let action = 'select';
                    let params = {};
                    params.type = 'qty';
                    params.v = qty;
                    conf.handleAction(action, params);
                }
            });
        }

        const width_plus_input = document.querySelector('#width-plus');

        if(width_plus_input){

            width_plus_input.addEventListener('click', function(e){

                conf.w ++;

                let action = 'select';
                let params = {};
                params.type = 'width';
                params.v = conf.w;
                conf.handleAction(action, params);
            });
        }

        const width_minus_input = document.querySelector('#width-minus');

        if(width_minus_input){

            width_minus_input.addEventListener('click', function(e){

                if(conf.w > 1){

                    conf.w --;

                    let action = 'select';
                    let params = {};
                    params.type = 'width';
                    params.v = conf.w;
                    conf.handleAction(action, params);
                }
            });
        }

        const height_plus_input = document.querySelector('#height-plus');

        if(height_plus_input){

            height_plus_input.addEventListener('click', function(e){

                conf.h ++;

                let action = 'select';
                let params = {};
                params.type = 'height';
                params.v = conf.h;
                conf.handleAction(action, params);
            });
        }

        const height_minus_input = document.querySelector('#height-minus');

        if(height_minus_input){

            height_minus_input.addEventListener('click', function(e){

                if(conf.h > 1){

                    conf.h --;

                    let action = 'select';
                    let params = {};
                    params.type = 'height';
                    params.v = conf.h;
                    conf.handleAction(action, params);
                }
            });
        }

        const qty_plus_input = document.querySelector('#qty-plus');

        if(qty_plus_input){

            qty_plus_input.addEventListener('click', function(e){

                conf.q ++;

                let action = 'select';
                let params = {};
                params.type = 'qty';
                params.v = conf.q;
                conf.handleAction(action, params);
            });
        }

        const qty_minus_input = document.querySelector('#qty-minus');

        if(qty_minus_input){

            qty_minus_input.addEventListener('click', function(e){

                if(conf.q > 1){

                    conf.q --;

                    let action = 'select';
                    let params = {};
                    params.type = 'qty';
                    params.v = conf.q;
                    conf.handleAction(action, params);
                }
            });
        }

        const designer_modal = document.querySelector('#designer-modal');

        if(designer_modal){

            $(designer_modal).on('show.bs.modal', function(e){

                let action = 'designer';
                let params = {};
                params.step = 1;
                conf.handleAction(action, params);
            });
        }

        const file_input = document.querySelector('#design-file-upload');

        if(file_input){

            $(file_input).on('change', function(e){

                let has_file = false;

                if($(file_input).get(0).files.length){
                    has_file = true;
                }

                let action = 'upload';
                let params = {};
                params.step = 1;
                params.has_file = has_file;
                conf.handleAction(action, params);
            });
        }

        const file_btn = document.querySelector('#design-upload-btn');

        if(file_btn && file_input){

            $(file_btn).on('click', function(e){

                console.log($(file_input).get(0).files);

                if($(file_input).get(0).files.length){

                    let action = 'upload';
                    let params = {};
                    params.step = 2;
                    params.size = $(file_input).get(0).files[0].size;
                    params.name = $(file_input).get(0).files[0].name;
                    params.type = $(file_input).get(0).files[0].type;
                    params.file = $(file_input).get(0).files[0];
                    conf.handleAction(action, params);    
                }
            });
        }

        const stay_btn = document.querySelector('#design-stay-btn');

        if(stay_btn){

            $(stay_btn).on('click', function(e){

                $('#upload-modal').modal('hide');
            });
        }

    }


    handleAction(action, params = {})
    {
        this.clearMessage();
        console.log('//START ACTION//');
        console.log(params, action);
        console.log(this.s, this.sp, this.o);

        switch (action) {

            case 'select':

                switch (params.type) {

                    case 'shape':

                        this.s = parseInt(params.v);
                        this.d = 0;
                        break;

                    case 'support':

                        this.sp = parseInt(params.v);
                        break;

                    case 'dimension':

                        this.w = parseInt(params.width);
                        this.h = parseInt(params.height);
                        break;

                    case 'quantity':

                        this.q = parseInt(params.qty);
                        break;

                    case 'wt':

                        this.wt = parseInt(params.v);
                        break;

                    case 'bat':

                        this.bat = parseInt(params.v);
                        break;

                    case 'opt':

                        this.o = parseInt(params.v);
                        break;

                    case 'width':

                        this.w = parseInt(params.v);
                        this.d = 0;
                        break;

                    case 'height':

                        this.h = parseInt(params.v);
                        this.d = 0;
                        break;

                    case 'qty':

                        this.q = parseInt(params.v);
                        break;

                    default:
                        break;   
                }

                this.load();
                break;

            case 'designer' :

                switch (params.step) {

                    case 1:

                        let formData = new FormData();
                        formData.append('action', 'initDesign');
                        formData.append('token', this.token);
                        formData.append('params[w]', this.w);
                        formData.append('params[h]', this.h);
                        formData.append('params[q]', this.q);
                        formData.append('params[s]', this.s);
                        formData.append('params[sp]', this.sp);
                        formData.append('params[o]', this.o);

                        this.loading_designer();

                        $('#upload-error-message').empty();

                        if(!$('#add-to-cart-action').hasClass('disabled')){
                            $('#add-to-cart-action').addClass('disabled');
                        }

                        this.url_cart = false;

                        $.ajax({
                            type: 'POST',
                            dataType: 'JSON',
                            url: this.url,
                            contentType: false,
                            processData: false,
                            data: formData,
                            context : this,
                            'success' : function(response){

                                if(response.success && response.content != ''){

                                    $('#designer-content').empty().append(response.content);

                                }
                                this.loading_designer(false);
                            },
                            'error' : function(){

                                this.dropMessage("Erreur technique, veuillez recharger la page. Si le problème persiste, merci de contacter l'administrateur du site.");
                                this.loading_designer(false);
                            }
                        });

                        break;

                    default:
                        break;  

                }  

                break;

            case 'upload' :

                switch (params.step) {

                    case 1 :

                        if(params.has_file){

                            $('#design-upload-btn').show();

                        }else{

                            $('#design-upload-btn').hide();
                        }

                        break;

                    case 2 :

                        let formData = new FormData();
                        formData.append('action', 'sendFile');
                        formData.append('token', this.token);
                        formData.append('params[name]', params.name);
                        formData.append('params[size]', params.size);
                        formData.append('params[type]', params.type);
                        formData.append('design_file', params.file);
                        formData.append('params[w]', this.w);
                        formData.append('params[h]', this.h);
                        formData.append('params[q]', this.q);
                        formData.append('params[s]', this.s);
                        formData.append('params[sp]', this.sp);
                        formData.append('params[o]', this.o);

                        $.ajax({
                            type: 'POST',
                            dataType: 'JSON',
                            url: this.url,
                            contentType: false,
                            processData: false,
                            data: formData,
                            context : this,
                            'success' : function(response){

                                console.log(response);

                                $('#upload-error-message').empty();

                                if( response.success ){

                                    $('#design-upload-btn').hide();
                                    this.dropMessage( response.message, false );
                                    $('#add-to-cart-action').removeClass('disabled');
                                    $('#upload-actions').removeClass('disabled');
                                    document.querySelector("#upload-actions .add-to-cart-action a").setAttribute("href", response.url_redirect);
                                    document.querySelector("#add-to-cart-action.add-to-cart-action a").setAttribute("href", response.url_redirect);
                                    this.url_cart = response.url_redirect;

                                }else{

                                    $('#upload-error-message').html(response.message);

                                    if(!$('#upload-actions').hasClass('disabled')){
                                        $('#upload-actions').addClass('disabled');
                                    }


                                    if(!$('.add-to-cart-action').hasClass('disabled')){
                                        $('.add-to-cart-action').addClass('disabled');
                                    }
                                    this.url_cart = false;
                                    document.querySelector("#upload-actions .add-to-cart-action a").setAttribute("href", "#");
                                    document.querySelector("#add-to-cart-action.add-to-cart-action a").setAttribute("href", "#");
                                }
                            },
                            'error' : function(){

                                this.dropMessage("Erreur technique, veuillez recharger la page. Si le problème persiste, merci de contacter l'administrateur du site.");
                            }
                        });
                        break;

                    default:
                        break;
                }

            default:
                break;
        }
        
    }



    clearMessage = () =>
    {
        $('#notifications').empty();
    }

    dropMessage = (message, error = true) =>
    {
        this.clearMessage();
        if(error){
            var strNotification = `<article class="alert alert-danger" role="alert" data-alert="danger"><ul><li>` +message+ `</li></ul></article>`;
        }else{
            var strNotification = `<article class="alert alert-success" role="alert" data-alert="success"><ul><li>` +message+ `</li></ul></article>`;
        }
        $('#notifications').html(strNotification);
    }


    loading = (show = true) =>
    {
        if(show){
            this.loading_screen.show();
        }else{
            this.loading_screen.hide();
        }
    }

    loading_designer = (show = true) =>
    {
        let loading_designer_screen = $('#designer-content-loader');

        if(loading_designer_screen){

            if(show){
                loading_designer_screen.show();
            }else{
                loading_designer_screen.hide();
            }   
        }
    }

    loadContent(content)
    {   
        this.container.empty().append(content);
        this.loadEvents();
    }

    parseParams(params)
    {
        params = String(params);
        params = params.replaceAll('\'', '"');
        params = params.replaceAll('[', '{');
        params = params.replaceAll(']', '}');
        return JSON.parse(params);

    }

}
const conf = new AE2Configurator();